import { render } from "./AddDocumentPage.vue?vue&type=template&id=5b4f6eff&ts=true"
import script from "./AddDocumentPage.vue?vue&type=script&lang=ts"
export * from "./AddDocumentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__